import React, { useCallback } from 'react';
import { GoogleLogin } from '@react-oauth/google';

function GoogleLoginButton({ onSuccess, onError, label }) {
  const handleSuccess = useCallback(credentialResponse => {
    if (!credentialResponse?.credential) {
      onError?.('No credential returned from Google.');
      return;
    }
    onSuccess(credentialResponse.credential);
  }, [onSuccess, onError]);

  const handleError = useCallback(() => {
    onError?.('Google sign-in failed. Please try again or use email login.');
  }, [onError]);

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <GoogleLogin
        theme="outline"
        size="large"
        shape="rectangular"
        text={label === 'signup' ? 'signup_with' : 'signin_with'}
        onSuccess={handleSuccess}
        onError={handleError}
        use_fedcm_for_button
      />
    </div>
  );
}

export default React.memo(GoogleLoginButton);
